import React from 'react';
import * as PropTypes from 'prop-types';

const JobTitleClusterFooter = (props) => {
  const { linksData, TitleTagName, id } = props;
  return (
    <div id={id} className="row job-title-cluster-footer">
      {linksData.map(({ title, links }, index) => {
        if (!links?.length) return null;
        return (
          <div className={`col-12 col-lg-3`} key={title + index}>
            <TitleTagName className="footer-link-list-title">{title}</TitleTagName>
            <ul className="footer-link-list">
              {links.map(({ rel, link, text, title }, index) => (
                <li key={index} className={`footer-link-list-item`}>
                  <a rel={rel} href={link} title={title}>
                    {text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

JobTitleClusterFooter.propTypes = {
  linksData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      links: PropTypes.array.isRequired,
    })
  ),
  totalColumnsInRow: PropTypes.number,
  TitleTagName: PropTypes.string,
};

JobTitleClusterFooter.defaultProps = {
  linksData: [],
  totalColumnsInRow: 4,
  TitleTagName: 'h3',
};

export default JobTitleClusterFooter;
